/*eslint-disable no-undef*/
require('expose-loader?Components!./components');
/*eslint-enable no-undef*/



// WEBPACK FOOTER //
// ./index.js